import RestEndpointsEnum from "../models/RestEndpointsEnum";
import { buildRestUrlWithQuery, buildAuthHeadersForFetch } from "./RestService";
import IUserUI from "../models/IUserUI";
import ISupplierModel from "../models/ISupplierModel";
import IAccount_Note from "../models/IAccount_Note";
import ICreateAccountNoteDTO from "../models/DTO/ICreateAccountNoteDTO";
import IUpdateAccountNoteDTO from "../models/DTO/IUpdateAccountNoteDTO";

const createAccountNote = async (dto: ICreateAccountNoteDTO, userModel: IUserUI, supplierModel: ISupplierModel): Promise<IAccount_Note> => {
    const url = buildRestUrlWithQuery({
        endpoint: RestEndpointsEnum.AccountNotesCreate,
    });

    const headers = buildAuthHeadersForFetch({ userModel, supplierModel });

    const response = await fetch(url, {
        method: "POST",
        headers: {
            ...headers,
            "Content-Type": "application/json",
        },
        body: JSON.stringify(dto),
    });

    if (!response.ok) {
        throw new Error(`Failed to create account note: ${response.statusText}`);
    }

    return (await response.json()) as IAccount_Note;
};

const updateAccountNote = async (
    id: number,
    dto: IUpdateAccountNoteDTO,
    userModel: IUserUI,
    supplierModel: ISupplierModel
): Promise<IAccount_Note> => {
    const url = buildRestUrlWithQuery({
        endpoint: RestEndpointsEnum.AccountNotesUpdate,
        params: { id },
    });

    const headers = buildAuthHeadersForFetch({ userModel, supplierModel });

    const response = await fetch(url, {
        method: "PUT",
        headers: {
            ...headers,
            "Content-Type": "application/json",
        },
        body: JSON.stringify(dto),
    });

    if (!response.ok) {
        throw new Error(`Failed to update account note: ${response.statusText}`);
    }

    return (await response.json()) as IAccount_Note;
};

const deleteAccountNote = async (id: number, userModel: IUserUI, supplierModel: ISupplierModel): Promise<void> => {
    const url = buildRestUrlWithQuery({
        endpoint: RestEndpointsEnum.AccountNotesDelete,
        params: { id },
    });

    const headers = buildAuthHeadersForFetch({ userModel, supplierModel });

    const response = await fetch(url, {
        method: "DELETE",
        headers,
    });

    if (!response.ok) {
        throw new Error(`Failed to delete account note: ${response.statusText}`);
    }
};

const AccountNotesService = {
    createAccountNote,
    updateAccountNote,
    deleteAccountNote,
};

export default AccountNotesService;
